module.exports = __webpack_public_path__ + "img/first5.7cc71b3e.png";